import { connect } from 'react-redux';
import * as bucketSelectors from '../../selectors/bucketSelectors';
import * as bucketSettingsSelectors from '../../selectors/bucketSettingsSelectors';
import * as bucketConstants from '../../constants/buckets';
import Settings from '../../components/settings/Settings';

const mapStateToProps = state => {
    return {
        name: bucketSettingsSelectors.getName(state),
        visibleInApplications: bucketSelectors.getAvailableApplicationsForBucket(
            state,
        ),
        selectedApplicationsIds: bucketSettingsSelectors.getAppsIds(state),
    };
};

const mapDispatchToProps = dispatch => ({
    onNameChange: reactEvent =>
        dispatch({
            type: bucketConstants.CHANGE_BUCKET_SETTINGS_NAME,
            payload: reactEvent.nativeEvent.target.value,
        }),
    onApplicationsChange: appIds =>
        dispatch({
            type: bucketConstants.CHANGE_BUCKET_SETTINGS_APPLICATION_IDS,
            payload: appIds,
        }),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Settings);



// WEBPACK FOOTER //
// ./src/containers/bucketSettings/BucketBasicSettings.js